import { buildPager, buildSearchStatus } from "https://static.cloud.coveo.com/headless/v3.19.2/headless.esm.js";
import { initializeBindings } from "https://static.cloud.coveo.com/atomic/v3.20.4/index.esm.js";

class SearchAnnouncer extends HTMLElement {
  announcer;
  bindings;
  summary;
  pagination;
  didInitialLoad = false;
  previousPage = 0;
  unsubscribe = () => {};

  async connectedCallback() {
    this.createAnnouncer();

    try {
      await customElements.whenDefined("atomic-search-interface");
      const searchInterface = document.querySelector(
        "atomic-search-interface"
      );
      if (!searchInterface) {
        throw new Error("atomic-search-interface not found on the page.");
      }

      this.bindings = await initializeBindings(searchInterface);
      this.initializeSearchController();
    } catch (error) {
      console.error("SearchAnnouncer failed to initialize:", error);
    }
  }

  initializeSearchController() {
    this.searchStatus = buildSearchStatus(this.bindings.engine);
    this.pagination = buildPager(this.bindings.engine);

    this.unsubscribe = this.searchStatus.subscribe(() => {
      const state = this.searchStatus.state;
      const isSearchComplete = !state.isLoading && !state.error;

      if (!isSearchComplete || !this.searchStatus.state.firstSearchExecuted) {
        return;
      }

      if (this.searchStatus.state.firstSearchExecuted && !this.didInitialLoad) {
        const message = `Search results are loaded.`;
        this.announce(message);
        this.didInitialLoad = true;
        return;
      }

      const currentPage = this.pagination.state.currentPage;

      if (currentPage > 1 && currentPage !== this.previousPage) {
        const message = `Search results are loaded for page ${
          currentPage
        }.`;
        this.announce(message);
      }

      this.previousPage = currentPage;
    });
  }

  disconnectedCallback() {
    this.unsubscribe();

    if (this.announcer) {
      this.announcer.remove();
    }
  }

  createAnnouncer() {
    const announcer = document.createElement("div");
    announcer.id = "commerce-announcer-live-region";
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("role", "status");
    announcer.setAttribute("aria-atomic", "true");
    Object.assign(announcer.style, {
      position: "absolute",
      width: "1px",
      height: "1px",
      margin: "-1px",
      padding: "0",
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      border: "0",
    });
    document.body.appendChild(announcer);
    this.announcer = announcer;
  }

  announce(message) {
    if (this.announcer) {
      this.announcer.innerHTML = "&nbsp;";
      setTimeout(() => {
        console.log(`📢 Announcing: "${message}"`);
        this.announcer.textContent = message;
      }, 150);
    }
  }
}

customElements.define("search-announcer", SearchAnnouncer);